import { render, staticRenderFns } from "./CompanyContact.vue?vue&type=template&id=c2c1ed90&scoped=true&"
import script from "./CompanyContact.vue?vue&type=script&lang=js&"
export * from "./CompanyContact.vue?vue&type=script&lang=js&"
import style0 from "./CompanyContact.vue?vue&type=style&index=0&id=c2c1ed90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c1ed90",
  null
  
)

export default component.exports